/**
 * Validation of custom prompts against the editable prompts from /api/reports/config.
 */

export const requiredPlaceholdersOf = (promptConfig) =>
  promptConfig.requiredPlaceholders || promptConfig.required_placeholders || [];

export const promptErrors = (promptText, requiredPlaceholders) => {
  if (!promptText || !promptText.trim()) return ['Prompt text cannot be empty'];
  const missing = requiredPlaceholders.filter((placeholder) => !promptText.includes(placeholder));
  return missing.length ? [`Missing required placeholders: ${missing.join(', ')}`] : [];
};

/**
 * @param {Object} customPrompts - prompt key -> prompt text
 * @param {Array} editablePrompts - [{ key, name, requiredPlaceholders }]
 * @returns {{ isValid: boolean, errors: Object }} errors maps prompt key -> messages
 */
export const validateAllPrompts = (customPrompts, editablePrompts) => {
  const errors = {};
  for (const [key, text] of Object.entries(customPrompts || {})) {
    const config = editablePrompts.find((p) => p.key === key);
    const messages = config
      ? promptErrors(text, requiredPlaceholdersOf(config))
      : [`Invalid prompt name: ${key}`];
    if (messages.length) errors[key] = messages;
  }
  return { isValid: Object.keys(errors).length === 0, errors };
};

/** One "  - Prompt name: message; message" line per prompt. */
export const formatValidationErrors = (errors, editablePrompts) => (
  Object.entries(errors || {})
    .map(([key, messages]) => {
      const name = editablePrompts.find((p) => p.key === key)?.name || key;
      return `  - ${name}: ${Array.isArray(messages) ? messages.join('; ') : messages}`;
    })
    .join('\n')
);
